var map = {
	"./10equalaccess.jpg": 1725,
	"./11gwtn.jpg": 1038,
	"./12icrc.jpg": 20,
	"./13ifes.jpg": 8381,
	"./14peeda.jpg": 8420,
	"./15peopleinneed.jpg": 4450,
	"./16unesco.jpg": 730,
	"./17vowmedia.jpg": 5052,
	"./18worldvisioin.jpg": 9592,
	"./19suryanepal.jpg": 7144,
	"./1unicef.jpg": 2627,
	"./20kedia.jpg": 5902,
	"./21cg.jpg": 9605,
	"./22bottlers nepal.jpg": 2579,
	"./23gorkhabrewery.jpg": 4913,
	"./24unilever.jpg": 3104,
	"./25sujaldairy.jpg": 1573,
	"./26sujalfoods.jpg": 5656,
	"./27agnigroup.jpg": 1689,
	"./28nepaldistilleries.jpg": 2171,
	"./29sab.jpg": 3577,
	"./2who.jpg": 9702,
	"./30asianpaints.jpg": 5062,
	"./31dabur.jpg": 3806,
	"./32dlf.jpg": 9745,
	"./33emami.jpg": 3565,
	"./34golchha.jpg": 2027,
	"./35maw.jpg": 6635,
	"./36hilife.jpg": 8612,
	"./37himelectronics.jpg": 6373,
	"./38piuro.jpg": 606,
	"./39shivam.jpg": 2458,
	"./3icimod.jpg": 3706,
	"./40skylight.jpg": 5549,
	"./41und.jpg": 9842,
	"./42varun.jpg": 7082,
	"./43samsung.jpg": 639,
	"./44baltra.jpg": 5576,
	"./45ce.jpg": 7393,
	"./46daraz.jpg": 9260,
	"./47better.jpg": 2581,
	"./48kansainerolac.jpg": 9061,
	"./49rbdiamond.jpg": 3969,
	"./4undp.jpg": 5311,
	"./50shreevairab.jpg": 5651,
	"./51herveda.jpg": 6883,
	"./52nepalliquors.jpg": 8340,
	"./53kasthamandap.jpg": 5383,
	"./54urban.jpg": 1839,
	"./55perfetti.jpg": 3449,
	"./56phoolprasad.jpg": 2242,
	"./57ebl.jpg": 1045,
	"./58kumaribank.jpg": 6724,
	"./59siddhartha.jpg": 8984,
	"./5STC.jpg": 7379,
	"./60himalayaneverstinsureance.jpg": 4036,
	"./61prabhumahalaxmi.jpg": 6701,
	"./62siddharthapremier.jpg": 5524,
	"./63nchl.jpg": 5548,
	"./64jlecc.jpg": 3145,
	"./65ku.jpg": 2791,
	"./66kvc.jpg": 3788,
	"./67kws.jpg": 668,
	"./68nba.jpg": 1449,
	"./69nepaltraveller.jpg": 3288,
	"./69taleju.jpg": 5252,
	"./6heifer.jpg": 3069,
	"./70pearlpublication.jpg": 1851,
	"./71echoad.jpg": 7544,
	"./72maxmedia.jpg": 1545,
	"./73outreach.jpg": 1531,
	"./74prismark.jpg": 5984,
	"./75vchitra.jpg": 3413,
	"./76pycus.jpg": 4147,
	"./77siddhipoly.jpg": 69,
	"./78klab.jpg": 8529,
	"./79HMH.jpg": 9449,
	"./7helvetas.jpg": 8009,
	"./80hotelmulberry.jpg": 690,
	"./8rtr.jpg": 752,
	"./9unfpa.jpg": 2359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9122;